
import Vue from "vue";

export default Vue.extend({
	props: {
		to: {type: String},
		disabled: {
			type: Boolean
		},
		showHandle: Boolean,
		error: Boolean
	},
	computed: {
		clickable(): boolean {
			if (this.disabled){
				return false;
			}
			if (this.to != null) {
				return true;
			}
			if (this.$listeners.click != null) {
				return true;
			}
			return false;
		}
	},
	methods: {
		click(e:Event) {
			if (this.disabled){
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				return;
			}
			if (this.to) {
				this.$router.push(this.to);
			}
			this.$emit("click");
		},
		onDrop(ev:DragEvent) {
			this.$emit("drop", ev);
		},
		onDragEnter(ev:DragEvent) {
			this.$emit("dragenter", ev);
		},
		onDragLeave(ev:DragEvent) {
			this.$emit("dragleave", ev);
		}
	}
});
